// extracted by mini-css-extract-plugin
export default {"sliderHome":"recommended_sliderHome__Lv0Zb","recommend":"recommended_recommend__ngWYe","recommendItem":"recommended_recommendItem__HqCns"};